module.exports = __webpack_public_path__ + "static/img/banner_solutions_web.20cdcde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/resource/images/solution/banner_solutions_web.png
// module id = ZzYj
// module chunks = 10